export const darkTheme = {
  scheme: "prelude-dark",
  base00: "transparent",
  base01: "#383830",
  base02: "#49483e",
  base03: "#75715e",
  base04: "#a59f85",
  base05: "#f8f8f2",
  base06: "#f5f4f1",
  base07: "#f9f8f5",
  base08: "#f92672",
  base09: "#fd971f",
  base0A: "#f4bf75",
  base0B: "#a6e22e",
  base0C: "#a1efe4",
  base0D: "#66d9ef",
  base0E: "#ae81ff",
  base0F: "#cc6633"
}

export const lightTheme = {
  scheme: "prelude-light",
  base00: "transparent",
  base01: "#e8e8e8",
  base02: "#d8d8d8",
  base03: "#b8b8b8",
  base04: "#585858",
  base05: "#383838",
  base06: "#282828",
  base07: "#181818",
  base08: "#d32f2f",
  base09: "#f57c00",
  base0A: "#fbc02d",
  base0B: "#388e3c",
  base0C: "#0097a7",
  base0D: "#1976d2",
  base0E: "#7b1fa2",
  base0F: "#795548"
}

export function getJsonTheme(theme: string) {
  const isDark = theme === "dark" || (theme === "system" && document.documentElement.classList.contains("dark"))
  return isDark ? darkTheme : lightTheme
}
